import React from "react";

const App = () => {
  return <p>Hello world!</p>;
};

export default App;
